import axios from 'axios';

class HaNotes {
  constructor() {
    if (document.getElementById('add')) {
      console.log('HaMynotes.js');
      this.addBtn = document.getElementById('add');
      this.container = document.getElementById('container');
      this.deleteBtn = document.getElementById('btnDelete');

      axios.defaults.headers.common['X-WP-Nonce'] = harzadventureData.nonce;

      this.getNotes();
      this.events();
    }
  }

  events() {
    this.addBtn.addEventListener('click', () => {
      if (!document.getElementById('newNote')) {
        this.addNewNote('newNote', '', '', true);
      }
    });
    this.deleteBtn.addEventListener('click', () => {
      //alert('NoteID: ' + this.deleteBtn.getAttribute('data-bs-id'));

      const noteid = this.deleteBtn.getAttribute('data-bs-id');
      this.deleteNote(noteid);
      document.getElementById(noteid).remove();
    });
  }

  async getNotes() {
    try {
      const response = await axios.get(
        harzadventureData.root_url + '/wp-json/wp/v2/notes/'
      );

      if (response.data) {
        response.data.forEach((note) =>
          this.addNewNote(note.id, note.title.rendered, note.content.rendered)
        );
        console.log(response);
      }
    } catch (e) {
      console.error(e);
    }
  }

  async createNote(title, content) {
    var ourNewPost = {
      title: title,
      content: content,
      status: 'publish',
    };

    try {
      const response = await axios.post(
        harzadventureData.root_url + '/wp-json/wp/v2/notes/',
        ourNewPost
      );
      return JSON.stringify(response.data.id);
    } catch (e) {
      console.error(e);
    }
  }

  async updateNote(noteid, title, content) {
    console.log(
      'updateNote: ' + noteid + ' - Title: ' + title + ' Content: ' + content
    );
    var ourUpdatedPost = {
      title: title,
      content: content,
    };
    try {
      const response = await axios.post(
        harzadventureData.root_url + '/wp-json/wp/v2/notes/' + noteid,
        ourUpdatedPost
      );
    } catch (e) {
      console.log('Sorry, die Notiz konnte nicht gespeichert werden.');
    }
  }

  async deleteNote(noteid) {
    console.log('deleteNote: ' + noteid);
    try {
      const response = await axios.delete(
        harzadventureData.root_url + '/wp-json/wp/v2/notes/' + noteid
      );
    } catch (e) {
      console.log('Sorry');
    }
  }

  addNewNote(noteid = '', title = '', text = '', editmode = false) {
    const note = document.createElement('div');

    note.classList.add('note');
    note.setAttribute('id', noteid);

    console.log('addNewNote: ' + noteid + ' - ' + title + text);
    text = this.stripTags(text);

    console.log('Editmode: ' + editmode);
    console.log('addNewNote clean: ' + noteid + ' - ' + title + text);

    note.innerHTML = `<div class="tools ${editmode ? 'editmode' : ''}">
    <div class="title ${editmode ? 'hidden' : ''}">${title}</div>
    <input class="${
      editmode ? '' : 'hidden'
    }" id="notetitle" type="text" placeholder="Titel eingeben" value="${title}">
    <div class="buttons">
        <button class="edit ${
          editmode ? 'hidden' : ''
        }" title="Bearbeiten"><i class="fas fa-edit"></i></button>
        <button class="save ${
          editmode ? '' : 'hidden'
        }" title="Speichern"><i class="fa-solid fa-floppy-disk"></i></button>
        <!-- Button trigger modal -->
        <button	type="button" class="delete" data-bs-id="${noteid}" data-bs-toggle="modal" data-bs-target="#confirmDialog" data-bs-msgtitle="Notiz löschen" data-bs-msgtext="Soll die Notiz <strong>${title}</strong> gelöscht werden?"data-bs-msgaction="" title="Notiz löschen"> <i class="fas fa-trash-alt"></i></button>
    </div>
    </div>
    <div class="main ${editmode ? 'hidden' : ''}"></div>
    <textarea class="${editmode ? '' : 'hidden'}"></textarea>
    `;

    const editBtn = note.querySelector('.edit');
    const saveBtn = note.querySelector('.save');
    const deleteBtnNote = note.querySelector('.delete');
    const main = note.querySelector('.main');
    const textArea = note.querySelector('textarea');
    const titleReadonly = note.querySelector('.title');
    const titleEdit = note.querySelector('#notetitle');
    const toolBar = note.querySelector('.tools');

    textArea.value = text;
    main.innerHTML = marked(text);

    deleteBtnNote.addEventListener('click', () => {
      this.deleteBtn.removeAttribute('href');
      this.deleteBtn.setAttribute('type', 'button');
      this.deleteBtn.setAttribute('data-bs-dismiss', 'modal');
      this.deleteBtn.style.color = 'white';
    });

    editBtn.addEventListener('click', () => {
      main.classList.toggle('hidden');
      editBtn.classList.toggle('hidden');
      saveBtn.classList.toggle('hidden');
      textArea.classList.toggle('hidden');
      titleReadonly.classList.toggle('hidden');
      titleEdit.classList.toggle('hidden');
      toolBar.classList.toggle('editmode');
    });

    saveBtn.addEventListener('click', () => {
      titleReadonly.innerHTML = titleEdit.value;
      main.classList.toggle('hidden');
      editBtn.classList.toggle('hidden');
      saveBtn.classList.toggle('hidden');
      textArea.classList.toggle('hidden');
      titleReadonly.classList.toggle('hidden');
      titleEdit.classList.toggle('hidden');
      toolBar.classList.toggle('editmode');

      const noteid = note.getAttribute('id');

      // Neue Notiz speichern oder die bestehende Notiz aktualisieren
      // wenn keine Daten eingegeben worden, wird keine neue Notiz erstellt
      if (noteid == 'newNote') {
        if ((titleEdit.value + textArea.value).length > 0) {
          note.setAttribute(
            'id',
            this.createNote(titleEdit.value, textArea.value)
          );
        }
      } else {
        this.updateNote(
          note.getAttribute('id'),
          titleEdit.value,
          textArea.value
        );
      }
    });

    textArea.addEventListener('input', (e) => {
      const { value } = e.target;

      main.innerHTML = marked(value);

      //this.updateLS();
    });

    container.appendChild(note);
  }

  // (A) STRIP TAGS FUNCTION
  stripTags(original) {
    original = original.replace(/(<([^>]+)>)/gi, '');
    original = original.replaceAll('&#8211;', '-');
    original = original.replaceAll('&#8222;', '"');
    original = original.replaceAll('&#8220;', '"');

    return original;
  }
}

export default HaNotes;
